import React, { useState, useEffect } from 'react';
import { getPublicCatalog } from "../../store/action/catalog";
import numeral from "numeral";
import moment from "moment";
import Stepper from 'react-stepper-horizontal';
import InputLocation from "../../components/atoms/InputLocation";
import { getPublicLogisticPricing } from "../../store/action/pricing";
import { courierWithInstantPickup } from "../../services/helpers/courier";
import ReactLoading from "react-loading";
import { createFormOrder } from "../../store/action/order";
import ReactInterval from "react-interval";
import { Button } from "../../components/buttons";
import { getContrast } from "../../services/helpers/color";
import { checkProductAvailability } from "../../store/action/product";
import { trackWithValue } from "../../services/analytics";

const PublicCatalog = (props) => {
    const [ stage, setStage ] = useState({
        name:'order',
        number:0
    });
    const [ addressType, setAddressType ] = useState('postalCode');
    const [ summaryLoading, setSummaryLoading] = useState(false);
    const [ values, setValues ] = useState({
        addressName:'',
        addressLocation:'',
        addressPhone:'',
        addressNote:'',
        addressPostalCode:0,
        addressCoordinate:{},
        addressProvinceName:'',
        addressCityName:'',
        addressDistrictName:'',
        bankAccounts:[],
        category:'',
        catalogId: '',
        categories:[],
        courierCompany: '',
        courierType: '',
        courierOption:[],
        couriers:[],
        deliveryType: 'later',
        deliveryDate: moment().format('YYYY-MM-DD') ,
        deliveryTime: moment().format('HH:mm:ss'),
        deliveryNote: '',
        description: '',
        fieldName: false,
        fieldEmail: false,
        fieldPhone: false,
        error:false,
        link:'',
        loading:true,
        orderItems: [],
        orderId:'',
        organizationId: '',
        orderNote:'',
        paymentImageLoading:false,
        paymentSlip: '',
        price: 0,
        receiverName: '',
        receiverPhone: '',
        receiverEmail: '',
        receiverLocation:'',
        receiverPostalCode: '',
        receiverCoordinate: {},
        receiverProvinceName:'-',
        receiverCityName:'-',
        receiverDistrictName:'-',
        receiverNote:'',
        subtitle: '',
        status: '',
        style: {},
        submitLoading:false,
        title: '',
        totalPrice:0,
        totalItems:0,
        userId: '',
        uniqueCode: Math.floor(Math.random() * 1000) + 1,
        volume:0,
        weight:0
    });

    useEffect(() => {
        _fetchData();
    }, []);

    const _fetchData = async () => {
        setValues({...values, loading:true});
        try {
            const resCat = await getPublicCatalog(
                props.match.params.catalogId,
                props.match.params.catalogName
            );
            let existingStyle = values.style;
            let newStyle = resCat.catalog.style;
            let style = {
                ...existingStyle,
                ...newStyle
            };

            let couriersOnly = [];
            resCat.couriers.map(i => {
                let courier = i.split(/_(.+)/)[0];
                let service = i.split(/_(.+)/)[1];
                if (!couriersOnly.includes(courier)) {
                    couriersOnly.push(courier);
                }
            });

            if (couriersOnly.includes('gojek') ||
                couriersOnly.includes('grab') ||
                couriersOnly.includes('deliveree')
            ) {
                setAddressType('coordinate')
            }

            let filteredCategories = resCat.catalog.categories.filter(i => i !== 'unknown');
            let removeUnknownCategoryProducts = resCat.catalog.products.filter(i => i.category !== 'unknown');
            let filteredProducts = removeUnknownCategoryProducts.filter(i => i.category === filteredCategories[0]);
            // set values

            setValues({
                ...values,
                addressName:resCat.catalog.address.name,
                addressPhone:resCat.catalog.address.phone,
                addressLocation:resCat.catalog.address.location,
                addressCoordinate:resCat.catalog.address.coordinate,
                addressNote:resCat.catalog.address.note,
                additionalItemName: resCat.catalog.additions.itemName,
                additionalItemPrice: resCat.catalog.additions.itemPrice,
                additionalItemCourierBased: resCat.catalog.additions.itemBasedOnCourierType,
                bankAccounts: resCat.bankAccounts,
                catalogId: resCat.catalog._id,
                categories: filteredCategories,
                category: filteredCategories[0],
                createdAt: resCat.catalog.createdAt,
                couriers: resCat.couriers,
                description: resCat.catalog.description,
                fieldName: resCat.catalog.fields.name,
                fieldEmail: resCat.catalog.fields.email,
                fieldPhone: resCat.catalog.fields.phone,
                fieldAdditionalItem: resCat.catalog.fields.additionalItem,
                link: resCat.catalog.link,
                loading:false,
                organizationId: resCat.catalog.organizationId,
                products: resCat.catalog.products,
                productsByCategory: filteredProducts,
                status: resCat.catalog.status,
                style: style,
                subtitle: resCat.catalog.subtitle,
                title: resCat.catalog.title,
                updatedAt: resCat.catalog.updatedAt,
                userId: resCat.catalog.userId
            });
        } catch (e) {
            console.log (e);
            alert(`Maaf. Gagal ambil data katalog.`);
            setValues({
                ...values,
                loading:false
            })
        }
    };

    const onSubmitOrder = async () => {
        setValues({...values,submitLoading:true});
        createFormOrder(values)
            .then(data => {
                if(data.error) {
                    setValues({
                        ...values,
                        submitLoading:false,
                        success: false,
                        error: data.error,
                        loading: false
                    });
                    alert(`${data.error}`)
                } else {

                    trackWithValue("Order Created",{
                        courier: {
                            company: values.courierCompany,
                            type: values.courierType
                        },
                        type: values.type,
                        revenue: values.price,
                        value: values.price,
                        currency: 'IDR',
                        action: "track",
                        category: "Orders",
                        label: 'Order From Form',
                        event: "Click"
                    });

                    setValues({
                        ...values,
                        success: true,
                        orderId: data.order._id,
                        submitLoading:false,
                        loading: false,
                    });
                    setStage({
                        name:'confirmation',
                        number:3
                    })
                }
            })
    };

    const handleChange = name => async e => {
        const value = e.target.value;
        setValues({ ...values, [name]: value });
        if (name === 'receiverPostalCode' && value.length === 5) {
            await onSelectLocation('','',value)
        }
    };

    const onLocationChange = a => {
        setValues({...values, receiverLocation:a})
    };

    const onAddItem = (i) => {
        let copyItems = values.products;
        let productId = i.id;
        for (let i = 0; i < copyItems.length; i++) {
            if (copyItems[i].id === productId) {
                if(copyItems[i].quantity === undefined){
                    copyItems[i].quantity=1
                } else {
                    copyItems[i].quantity+=1;
                }
            }
        }
        let orderItems = copyItems.reduce((res,i) => {
            if (i.quantity > 0) {
                res.push({
                    id: i.id,
                    name: i.name,
                    image: i.image,
                    description: `${i.category} - ${i.details}`,
                    value: i.price,
                    quantity: i.quantity,
                    height: i.height,
                    length: i.length,
                    weight: i.weight,
                    width: i.width,
                })
            }
            return res
        },[]);

        let totalItems = orderItems.reduce((res,i) => {
            res += i.quantity;
            return parseInt(res)
        },[]);
        let totalPrice = orderItems.reduce((res,i) => {
            res += i.value*i.quantity;
            return parseInt(res)
        },[]);
        let totalVolume = orderItems.reduce((res,i) => {
            res += i.length*i.height*i.width*i.quantity;
            return parseInt(res)
        },[]);
        let totalWeight = orderItems.reduce((res,i) => {
            res += i.weight*i.quantity;
            return parseInt(res)
        },[]);


        setValues({
            ...values,
            orderItems: orderItems,
            totalPrice: totalPrice,
            totalItems: totalItems,
            volume:totalVolume,
            weight:totalWeight,
            courierCompany:'',
            receiverLocation:'',
            receiverPostalCode: '',
            receiverCoordinate: {},
            receiverProvinceName:'-',
            receiverCityName:'-',
            receiverDistrictName:'-',
            courierOption:[]
        })
    };

    const onRemoveItem = (i) => {
        let copyItems = values.products;
        let productId = i.id;
        for (let i = 0; i < copyItems.length; i++) {
            if (copyItems[i].id === productId) {
                if(copyItems[i].quantity <= 0){
                    copyItems[i].quantity=0
                } else {
                    copyItems[i].quantity-=1;
                }
            }
        }

        let orderItems = copyItems.reduce((res,i) => {
            if (i.quantity > 0) {
                res.push({
                    id: i.id,
                    name: i.name,
                    image: i.image,
                    description: `${i.category} - ${i.details}`,
                    value: i.price,
                    quantity: i.quantity,
                    height: i.height,
                    length: i.length,
                    weight: i.weight,
                    width: i.width
                })
            }
            return res
        },[]);

        let totalItems = orderItems.reduce((res,i) => {
            res += i.quantity;
            return parseInt(res)
        },[]);
        let totalPrice = orderItems.reduce((res,i) => {
            res += i.value*i.quantity;
            return parseInt(res)
        },[]);
        let totalVolume = orderItems.reduce((res,i) => {
            res += i.length*i.height*i.width*i.quantity;
            return parseInt(res)
        },[]);
        let totalWeight = orderItems.reduce((res,i) => {
            res += i.weight*i.quantity;
            return parseInt(res)
        },[]);

        setValues({
            ...values,
            items:copyItems,
            orderItems: orderItems,
            totalPrice: totalPrice,
            totalItems: totalItems,
            volume: totalVolume,
            weight: totalWeight,
            courierCompany:'',
            receiverLocation:'',
            receiverPostalCode: '-',
            receiverCoordinate: {},
            receiverProvinceName:'-',
            receiverCityName:'-',
            receiverDistrictName:'-',
            courierOption:[]
        })
    };

    const onSelectCategory = (category) => {
        let filteredProducts =  values.products.filter(i => i.category === category);
        setValues({
            ...values,
            category,
            productsByCategory: filteredProducts
        })
    };

    const onCheckProduct = async () => {
        if (!values.receiverName) {
            alert("Mohon masukkan nama penerima");
            return
        }
        if (!values.receiverPhone) {
            alert("Mohon masukkan nomor telepon penerima");
            return
        }
        if (!values.receiverPostalCode) {
            alert("Mohon masukkan kodepos");
            return
        }
        if (!values.receiverEmail) {
            alert("Mohon masukkan email penerima");
            return
        }

        setSummaryLoading(true);
        try {
            let order = {
                receiverName: values.receiverName,
                receiverPhone: values.receiverPhone,
                receiverEmail: values.receiverEmail,
                receiverLocation: values.receiverLocation,
                receiverNote: values.receiverNote,
                receiverCoordinate: values.receiverCoordinate,
                orderItems: values.orderItems,
                originName: values.addressName,
                originLocation: values.addressLocation,
                originPhone: values.addressPhone,
                originNote: values.addressNote,
                originCoordinate: values.addressCoordinate,
                courierCompany: values.courierCompany,
                courierType: values.courierType,
                deliveryDate: values.deliveryDate,
                deliveryTime: values.deliveryTime,
                deliveryType: 'later',
                weight: values.weight,
                volume: values.volume,
                paymentType: 'online',
                paymentSlip: values.paymentSlip,
                price: values.price,
                orderNote: values.orderNote
            };

            const resCheck = await checkProductAvailability(values.catalogId, values.userId, order );

            if (resCheck.success) {
                setStage({name:'payment', number:2})
            } else {
                alert(`${resCheck.error}`)
            }

        } catch (e) {
            console.log (e)
        }
        setSummaryLoading(false);
    };

    const onSelectLocation = async (a,c,pc) => {
        setValues({...values, courierLoading:true});
        const res = await getPublicLogisticPricing(
            values.userId,
            values.catalogId,
            values.addressCoordinate,
            c,
            values.orderItems,
            values.couriers,
            addressType,
            pc,
        );

        if (res.pricing && res.success){
            let co = res.pricing[0];
            let loc = res.destination;
            let deliveryType;
            if (courierWithInstantPickup(co.company)) {
                deliveryType = 'now'
            } else {
                deliveryType = 'later'
            }
            if (addressType === 'postalCode') {
                setValues({
                    ...values,
                    courierLoading:false,
                    courierCompany:co.company,
                    courierType:co.type,
                    courierOption:res.pricing,
                    deliveryType,
                    receiverPostalCode: loc.postalCode,
                    receiverProvinceName: loc.provinceName,
                    receiverCityName: loc.cityName,
                    receiverDistrictName: loc.districtName,
                    price:co.price
                })
            } else {
                setValues({
                    ...values,
                    courierLoading:false,
                    courierCompany:co.company,
                    courierType:co.type,
                    courierOption:res.pricing,
                    deliveryType,
                    receiverLocation:a,
                    receiverCoordinate:c,
                    receiverPostalCode: loc.postalCode,
                    receiverProvinceName: loc.provinceName,
                    receiverCityName: loc.cityName,
                    receiverDistrictName: loc.districtName,
                    price:co.price
                })
            }

        } else if (!res.success) {
            setValues({
                ...values,
                courierLoading:false,
                locationLoading: false,
                courierOption:[],
                price:0
            });
            return alert(res.error);
        } else {
            setValues({
                ...values,
                courierLoading:false,
                courierCompany:'',
                courierType:'',
                courierOption:[],
                receiverLocation:a,
                receiverCoordinate:c,
                price:0
            })
        }
    };

    const onSelectCourier = (courier) => {
        if (courierWithInstantPickup(courier.company)) {
            setValues({
                ...values,
                courierCompany: courier.company,
                courierType: courier.type,
                price: courier.price
            })
        } else {
            setValues({
                ...values,
                courierCompany: courier.company,
                courierType: courier.type,
                price: courier.price,
                paymentType: 'online',
                deliveryType: 'later'
            })
        }
    };

    const productView = (type, products) => {
        let items;
        if (type === 'static') {
            items = products.map((i,idx) => (
                <div key={idx} className="row py-1">
                    <div className="col-9">
                        <div className="row">
                            <div className="col-4 pt-1">
                                {
                                    i.image ?
                                        <img src={i.image} style={{height:35, width:36}} className="rounded"/> :
                                        <i>no image</i>
                                }
                            </div>
                            <div className="col-6 text-left">
                                {i.quantity}x - <b>{i.name}</b>
                                <p className="mb-0">{i.description}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 text-right">
                        <b>Rp. {numeral(i.value*i.quantity).format("0,0")}</b>
                    </div>
                </div>
            ));
        } else {
            items = products.map((i,idx) => (
                <div className="container pl-4">
                    <div key={idx} className="row form-product py-1 px-3">
                        <div className="col-3">
                            {
                                i.image ?
                                    <img src={i.image} style={{height:100, width:100}} className="rounded"/> :
                                    <i>no image</i>
                            }
                        </div>
                        <div className="col-6 text-left pl-4">
                            <b>{i.name}</b>
                            <p className="mb-0">{i.details}</p>
                            {
                                i.stock === 0 ?
                                    <div>
                                        <i><b className="text-danger">Stok Habis</b></i>
                                        <br/>
                                    </div>
                                     :
                                    ''
                            }
                            <b>Rp. {numeral(i.price).format("0,0")}</b>
                        </div>
                        <div className="col-3">
                            <div
                                className="btn-group btn-group-sm"
                                style={{marginTop:-24}}
                                role="group">
                                <button
                                    onClick={() => onRemoveItem(i)}
                                    className="btn btn-primary btn-sm"
                                    style={{
                                        backgroundColor:values.style.buttonColor,
                                        borderColor:values.style.buttonBorderColor,
                                        color:values.style.buttonFontColor
                                    }}
                                >
                                    -
                                </button>
                                {
                                    i.quantity ?
                                        <div className="btn px-1">
                                            <b>{i.quantity}</b>
                                        </div>
                                        : ''
                                }
                                <button
                                    onClick={() => onAddItem(i)}
                                    className="btn btn-primary btn-sm"
                                    style={{
                                        backgroundColor:values.style.buttonColor,
                                        borderColor:values.style.buttonBorderColor,
                                        color:values.style.buttonFontColor
                                    }}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ));
        }


        return (
            <div>
                {items}
            </div>
        )
    };

    const priceView = () => {
        if (values.orderItems.length === 0) {
            return ''
        }

        return (
            <div className="row py-2">
                <div className="col-6">
                    Total Harga: <b>Rp. {numeral(values.totalPrice + values.price).format("0,0")}</b>
                </div>
                <div className="col-6">
                    Total Barang: <b>{ values.totalItems }</b>
                </div>
            </div>
        )
    };

    if (values.loading) {
        return <div className="bg-lighter"><b>Loading...</b></div>
    }

    let totalPrice, itemView;
    if (values.additionalItemPrice > 0 && values.additionalItemCourierBased === 'instant' && (values.courierCompany ==='gojek' || values.courierCompany ==='grab')) {
        totalPrice = `Rp. ${numeral(values.price + values.totalPrice + values.uniqueCode + values.additionalItemPrice).format("0,0")}`;
        itemView = (
            <div className="row justify-content-between">
                <div className="col-6">
                    Biaya Tambahan <b>1x {values.additionalItemName}</b>
                </div>
                <div className="col-6 text-right">
                    <b>Rp. {numeral(values.additionalItemPrice).format("0,0")}</b>
                </div>
            </div>
        )
    } else if (values.additionalItemPrice > 0 && values.additionalItemCourierBased === 'non-instant' && !(values.courierCompany ==='gojek' || values.courierCompany ==='grab')) {
        totalPrice = `Rp. ${numeral(values.price + values.totalPrice + values.uniqueCode + values.additionalItemPrice).format("0,0")}`;
        itemView = (
            <div className="row justify-content-between">
                <div className="col-6">
                    Biaya Tambahan <b>1x {values.additionalItemName}</b>
                </div>
                <div className="col-6 text-right">
                    <b>Rp. {numeral(values.additionalItemPrice).format("0,0")}</b>
                </div>
            </div>
        )
    } else {
        totalPrice = `Rp. ${numeral(values.price + values.totalPrice + values.uniqueCode).format("0,0")}`;
        itemView = ``;
    }

    let formBody;

    if (stage.name === 'order') {
        let categories = values.categories.filter(i => i !== 'unknown');
        formBody = (
            <div className={`text-center bg-white py-4 border rounded-bottom`}>
                <h2 style={{
                    fontFamily: values.style.titleFontFamily
                }}>
                    { values.title}
                </h2>
                <h5 style={{
                    fontFamily: values.style.subtitleFontFamily
                }}>
                    { values.subtitle}
                </h5>
                <p>{ values.description}</p>
                <div className="scroll-category-menu border-top border-bottom mb-4">
                    {
                        categories.map((i,idx) => (
                            <a key={idx} className="pointer" onClick={() => onSelectCategory(i)}>
                                {
                                    i === values.category ?
                                        <div className="px-4 py-2 border rounded"
                                             style={{
                                                 backgroundColor:values.style.buttonColor,
                                                 color: values.style.buttonFontColor
                                             }}>
                                            <b>{i}</b>
                                        </div> : <div>{i}</div>
                                }
                            </a>
                        ))
                    }
                </div>

                { productView('dynamic',values.productsByCategory) }

                <div className="col-12 mt-4 border-top">
                    { priceView() }
                    <button
                        onClick={ values.orderItems.length > 0 ?
                            () => setStage({name:'summary', number:1}) :
                            () => alert("Anda belum pesan apa-apa")
                        }
                        className="btn btn-primary btn-block"
                        style={ values.orderItems.length > 0 ? {
                            backgroundColor: values.style.buttonColor,
                            borderColor: values.style.buttonBorderColor,
                            color: values.style.buttonFontColor
                        } : {
                            backgroundColor: '#ced4da',
                            borderColor: '#ced4da',
                            color: 'black'
                        }}
                    >
                        Lanjut
                    </button>
                </div>
            </div>
        )
    } else if (stage.name === 'summary') {
        let products = values.products.filter(i => i.quantity > 0);
        formBody =  (
            <div className={`text-center bg-white py-4 border rounded-bottom`}>
                <h5 style={{
                    fontFamily: values.style.subtitleFontFamily
                }}>
                    Ringkasan Pembelian
                </h5>

                { productView('dynamic', products) }

                <hr/>

                <div className="text-left container">
                    <h6>Detil Penerima</h6>
                    <div className="form-row">
                        <div className="form-group col-6 input-group-sm">
                            <label>Nama Lengkap Penerima </label>
                            <input
                                type="text"
                                onChange={handleChange('receiverName')}
                                placeholder="Nama Lengkap"
                                className="form-control"
                                value={values.receiverName}
                            />
                        </div>
                        <div className="col-6">
                            <label>No HP Penerima</label>
                            <div className="form-group input-group input-group-sm">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">+62</span>
                                </div>
                                <input
                                    type="number"
                                    onChange={handleChange('receiverPhone')}
                                    placeholder="Nomor HP / Rumah"
                                    className="form-control"
                                    value={values.receiverPhone}
                                />
                            </div>
                        </div>
                    </div>
                    {
                        values.fieldEmail ?
                            <div>
                                <label>Email Penerima</label>
                                <div className="form-group input-group input-group-sm">
                                    <input
                                        type="email"
                                        onChange={handleChange('receiverEmail')}
                                        placeholder="xxx@yyy.com"
                                        className="form-control"
                                        value={values.receiverEmail}
                                    />
                                </div>
                            </div>
                            :
                            ''
                    }
                    {
                        addressType === 'postalCode' ?
                            <div className="form-row">
                                <div className="form-group input-group-sm col-9">
                                    <label>Alamat Lengkap Penerima</label>
                                    <input
                                        type="text"
                                        onChange={handleChange('receiverLocation')}
                                        placeholder="Nomor Rumah / patokan atau deskripsi alamat kamu"
                                        className="form-control"
                                        value={values.receiverLocation}
                                    />
                                    <small>{values.receiverDistrictName !== '-' ? `${values.receiverDistrictName}, ${values.receiverCityName}, ${values.receiverProvinceName}` : null }</small>
                                </div>
                                <div className="form-group input-group-sm col-3">
                                    <label>Kodepos</label>
                                    <input
                                        type="text"
                                        onChange={handleChange('receiverPostalCode')}
                                        placeholder="Kodepos"
                                        className="form-control"
                                        value={values.receiverPostalCode}
                                    />
                                </div>
                            </div>
                            :
                            <div>
                                <div className="form-group mb-1">
                                    <label>Alamat Penerima</label>
                                    <InputLocation
                                        setLocation={onSelectLocation}
                                        onLocationChange={onLocationChange}
                                        value={values.receiverLocation}
                                        placeholder={'Masukan lokasi tujuan'}
                                        loading={values.courierLoading}
                                        loadingText={"Mohon ditunggu. Sedang menghitung ongkir..."}
                                    />
                                    <small>{values.receiverDistrictName !== '-' ? `${values.receiverDistrictName}, ${values.receiverCityName}, ${values.receiverProvinceName}, ${values.receiverPostalCode}` : null }</small>
                                </div>

                                <div className="form-group input-group-sm">
                                    <label>Info Tambahan (Opsional)</label>
                                    <input
                                        type="text"
                                        onChange={handleChange('receiverNote')}
                                        placeholder="Patokan atau deskripsi alamat kamu (Opsional)"
                                        className="form-control"
                                        value={values.receiverNote}
                                    />
                                </div>
                            </div>
                    }
                </div>

                <hr className="mb-0"/>

                <div
                    style={values.courierOption.length > 0 ? {height:256} : {height:100}}
                    className="text-left container bg-lighter courier-window courier-option-section"
                >
                    <h6 className="pt-3">Pilih Kurir Pengiriman</h6>
                    {
                        values.courierOption.length === 0 && !values.courierLoading ?
                            <div>
                                Untuk tahu harga ongkir, tentukan / tulis ulang destinasi pengiriman terlebih dahulu ya :)
                            </div> : ''
                    }
                    {
                        values.courierOption.length > 0 && !values.courierLoading?
                            <div>
                                {
                                    values.courierOption.map((i,idx) => (
                                        <div
                                            key={idx}
                                            className={
                                                `col-12 py-1 rounded mb-2 courier-option d-flex justify-content-between
                          ${values.courierCompany === i.company && values.courierType === i.type ?
                                                    "courier-selected" : ""
                                                }`
                                            }
                                            onClick={() => onSelectCourier(i)}
                                        >
                                            <div>
                                                <b>{i.company === 'jnt' ? 'J&T' : i.company.toUpperCase()}</b><br/>
                                                <i>{i.type.toUpperCase()} - {i.description}</i>
                                            </div>
                                            <div className="text-right">
                                                <b className="text-success text-right">Rp. {numeral(i.price).format("0,0")}</b><br/>
                                                <p className="m-0 text-right">{i.duration}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            : ''
                    }
                    {
                        values.courierLoading ?
                            <div className="align-items-center">
                                <ReactLoading
                                    type={'bubbles'}
                                    color={'#459BD8'}
                                    height={36}
                                    width={36}
                                />
                                <b>Mencari Kurir...</b>
                            </div>
                            : ''
                    }
                </div>

                <div className="col-12 border-top">
                    { priceView() }
                    <Button
                        loading={summaryLoading}
                        onClick={values.courierCompany ?
                            () => onCheckProduct() :
                            () => alert("Mohon pilih kurir dulu ya :)")
                        }
                        className="btn btn-primary btn-block"
                        style={ values.courierCompany ? {
                            backgroundColor: values.style.buttonColor,
                            borderColor: values.style.buttonBorderColor,
                            color: values.style.buttonFontColor
                        } : {
                            backgroundColor: '#ced4da',
                            borderColor: '#ced4da',
                            color: 'black'
                        }}
                    >
                        Lanjut
                    </Button>
                </div>
            </div>
        )
    } else if (stage.name === 'payment') {

        let uniqueCode = totalPrice.substr(totalPrice.length -3);
        let filteredUnique = totalPrice.slice(0, -3);
        let totalPriceView = (
            <div>
                <h3><b>{filteredUnique}<mark>{uniqueCode}</mark></b></h3>
            </div>
        );

        formBody = (
            <div className={`text-left bg-white py-4 border rounded-bottom`}>
                <div className="container">
                    <h6>Rincian Pembayaran</h6>
                    <div className="p-4 border bg-lighter rounded">
                        <div className="row justify-content-between">
                            <div className="col-6">
                                Jumlah Barang <b>{values.totalItems}x</b>
                            </div>
                            <div className="col-6 text-right">
                                <b>Rp. {numeral(values.totalPrice).format("0,0")}</b>
                            </div>
                        </div>
                        {itemView}
                        <div className="row justify-content-between">
                            <div className="col-6">
                                Kurir <b>{values.courierCompany} - { values.courierType}</b>
                            </div>
                            <div className="col-6 text-right">
                                <b>Rp. {numeral(values.price).format("0,0")}</b>
                            </div>
                        </div>
                        <br/>
                        <div className="row justify-content-between">
                            <div className="col-6">
                                Kode Unik Pembayaran
                            </div>
                            <div className="col-6 text-right">
                                <b>{values.uniqueCode}</b>
                            </div>
                        </div>
                        <div className="container">
                            <hr/>
                        </div>
                        <div className="text-center">
                            <h6>Total Pembayaran</h6>
                            { totalPriceView }
                        </div>
                        <div className="text-left">
                            <b className="text-danger">PENTING!</b>
                            <p className="mb-1">* Mohon masukkan 3 angka terakhir untuk memudahkan pengecekan</p>
                            <p>** Setelah klik tombol di bawah, Anda akan menerima email yang berisi link pembayaran</p>
                        </div>
                    </div>
                    <br/>
                </div>
                <div className="border-top col-12 pt-3">
                    <Button
                        onClick={() => onSubmitOrder()}
                        loading={values.submitLoading}
                        className="btn btn-primary btn-block"
                        style={{
                            backgroundColor: values.style.buttonColor,
                            borderColor: values.style.buttonBorderColor,
                            color: values.style.buttonFontColor
                        }}
                    >
                        {values.submitLoading ? "Memproses..." : "Klik disini untuk bayar"}
                    </Button>
                </div>
            </div>
        )
    } else if (stage.name === 'confirmation') {
        formBody = (
            <div className={`text-left bg-white py-4 px-2 border rounded-bottom`}>
                <div className="my-2 text-center">
                    <i style={{fontSize: 32}} className="fas fa-check-circle text-success"/><br/>
                    <span><b className="text-black text-lg">Order Berhasil!</b></span> <br/>
                </div>
                <div className="text-center">
                    <p className="mb-1">No Transaksi Anda</p>
                    <h6 className="text-uppercase"><mark>{values.orderId}</mark></h6>
                    <p>Mohon <b className="text-danger">Upload bukti pembayaran</b> yang dikirimkan ke email Anda.</p>
                </div>
                <div className="container mb-3 border bg-lighter rounded p-2">
                    <h6>Detail Penerima</h6>
                    <div className="row">
                        <div className="col">
                            Penerima: <b>{values.receiverName}</b>
                        </div>
                        <div className="col text-right">
                            No Telepon: <b>{values.receiverPhone}</b>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            Email: <b>{values.receiverEmail}</b>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <p className="mb-0">Alamat</p>
                            <b>{values.receiverLocation}</b>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            Catatan: <b>{values.receiverNote}</b>
                        </div>
                        <div className="col text-right">
                            Kodepos: <b>{values.receiverPostalCode}</b>
                        </div>
                    </div>
                </div>
                <div className="container border bg-lighter rounded p-2">
                    <h6>Rincian Pesanan</h6>
                    { productView('static', values.orderItems) }
                    <div className="row">
                        <div className="col">
                            Kurir <b>{values.courierCompany} - {values.courierType}</b>
                        </div>
                        <div className="col text-right">
                            <b>Rp. {numeral(values.price).format("0,0")}</b>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            Kode Unik
                        </div>
                        <div className="col text-right">
                            <b>{values.uniqueCode}</b>
                        </div>
                    </div>
                    <hr className="my-2"/>
                    <div className="row">
                        <div className="col">
                            Total Pembayaran
                        </div>
                        <div className="col text-right">
                            <b>{totalPrice}</b>
                        </div>
                    </div>
                </div>
                <div className="border-top col-12 pt-3">
                    <button
                        onClick={() => window.location.assign(`/catalog/pf/${values.orderId}/${values.uniqueCode}/payment`)}
                        className="btn btn-primary btn-block"
                        style={{
                            backgroundColor: values.style.buttonColor,
                            borderColor: values.style.buttonBorderColor,
                            color: values.style.buttonFontColor
                        }}
                    >
                        Klik disini untuk konfirmasi bayar
                    </button>
                </div>
                <div className="border-top col-12 pt-3">
                    <button
                        onClick={() => window.location.reload()}
                        className="btn btn-primary btn-block"
                        style={{
                            backgroundColor: '#ced4da',
                            borderColor: '#ced4da',
                            color: 'black'
                        }}
                    >
                        Klik disini untuk Pesan Lagi?
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div className="px-0 border-top full-height"
             style={{
                 backgroundColor: values.style.backgroundColor
             }}
        >
            <div className="px-4" style={{
                backgroundColor: values.style.backgroundColor
            }}>
                <br/>
                <div
                    style={{width:528}}
                    className="container mt-4 rounded-circle public-form-layout">

                    <div className="align-self-center rounded-top">
                        <div
                            className="bg-lighter rounded-top"
                            style={{
                                height:156,
                                overflow: 'hidden',
                                align: 'center'
                            }}
                        >
                            <img
                                className="image-header-form"
                                src={values.style.headerImage}
                            />
                        </div>
                    </div>
                    <div className="pt-1 pb-4 bg-white">
                        <Stepper
                            circleFontSize={12}
                            size={28}
                            className="pointer"
                            titleFontSize={12}
                            completeColor={values.style.buttonColor}
                            activeColor={values.style.buttonColor}
                            circleFontColor={values.style.buttonFontColor}
                            steps={[
                                {
                                    title: 'Order',
                                    onClick: stage.name === 'confirmation' ? '' : () => setStage({name:'order',number:0})
                                },
                                {
                                    title: 'Ringkasan',
                                    onClick: stage.name === 'confirmation' ? '' : () => setStage({name:'summary',number:1})
                                },
                                {
                                    title: 'Pembayaran',
                                    onClick: stage.name === 'confirmation' ? '' : () => setStage({name:'payment',number:2})
                                },
                                {
                                    title: 'Konfirmasi',
                                    onClick: () => setStage({name:'confirmation',number:3})
                                }
                            ]}
                            activeStep={stage.number} />
                    </div>
                    { formBody }
                </div>
            </div>
            <div
                style={{
                    paddingTop: 64,
                    paddingBottom:64,
                    backgroundColor: values.style.backgroundColor
                }}
            >
                <div className="text-center public-form-layout">
                    <a
                        href='https://www.biteship.com'
                        style={ getContrast(values.style.backgroundColor) === 'white' ? {color:'white'} : {color:'black'}}
                    >
                        <p className="mb-1">
                            Form Powered by <i><b>Biteship</b></i>
                        </p>
                        <div style={{fontSize:12}}>
                            www.biteship.com
                        </div>
                    </a>
                </div>

            </div>
        </div>
    )

};




export default PublicCatalog;
